import styled from "styled-components";

export const StyledContent = styled.div`
  margin-top: 50px;
  width: 100vw;
  max-width: 100%;
  display: flex;
`;
